<template>
  <f7-page
    :page-content="false"
  >
    <f7-navbar
      innerClass="navbar-separator"
    >
      <!-- <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link> -->
      <f7-nav-title class="text-madai">Portafolio</f7-nav-title>
    </f7-navbar>

    <f7-toolbar tabbar scrollable :position="'top'">
      <f7-link tab-link="#tab-portafolio-1" tab-link-active>
        <img src="//movil.madai.mx/360/adn/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-2">
        <img src="//movil.madai.mx/360/edgar_horacio/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-3">
        <img src="//movil.madai.mx/360/erick_vazquez/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-4">
        <img src="//movil.madai.mx/360/guns_roses/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-5">
        <img src="//movil.madai.mx/360/jorge_dux/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-6">
        <img src="//movil.madai.mx/360/luis_femsa/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-7">
        <img src="//movil.madai.mx/360/mario_bros/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-8">
        <img src="//movil.madai.mx/360/raul_palacios/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-9">
        <img src="//movil.madai.mx/360/rostros/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-10">
        <img src="//movil.madai.mx/360/san_valentin/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-11">
        <img src="//movil.madai.mx/360/schnauzer/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-12">
        <img src="//movil.madai.mx/360/trifuerza/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-13">
        <img src="//movil.madai.mx/360/tulipan/menu.png" alt="" width="50">
      </f7-link>
      <f7-link tab-link="#tab-portafolio-14">
        <img src="//movil.madai.mx/360/ricardo/menu.png" alt="" width="50">
      </f7-link>
    </f7-toolbar>

    <f7-tabs swipeable>
      <f7-tab id="tab-portafolio-1" class="page-content" tab-active>
        <adn />
      </f7-tab>
      <f7-tab id="tab-portafolio-2" class="page-content">
        <edgar />
      </f7-tab>
      <f7-tab id="tab-portafolio-3" class="page-content">
        <erick />
      </f7-tab>
      <f7-tab id="tab-portafolio-4" class="page-content">
        <guns />
      </f7-tab>
      <f7-tab id="tab-portafolio-5" class="page-content">
        <dux />
      </f7-tab>
      <f7-tab id="tab-portafolio-6" class="page-content">
        <femsa />
      </f7-tab>
      <f7-tab id="tab-portafolio-7" class="page-content">
        <mario />
      </f7-tab>
      <f7-tab id="tab-portafolio-8" class="page-content">
        <raul />
      </f7-tab>
      <f7-tab id="tab-portafolio-9" class="page-content">
        <rostros />
      </f7-tab>
      <f7-tab id="tab-portafolio-10" class="page-content">
        <valentin />
      </f7-tab>
      <f7-tab id="tab-portafolio-11" class="page-content">
        <schnauzer />
      </f7-tab>
      <f7-tab id="tab-portafolio-12" class="page-content">
        <trifuerza />
      </f7-tab>
      <f7-tab id="tab-portafolio-13" class="page-content">
        <tulipan />
      </f7-tab>
      <f7-tab id="tab-portafolio-14" class="page-content">
        <ricardo />
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>

<script>
import adn from './portafolio/adn.vue'
import edgar from './portafolio/edgar.vue'
import erick from './portafolio/erick.vue'
import guns from './portafolio/guns.vue'
import dux from './portafolio/dux.vue'
import femsa from './portafolio/femsa.vue'
import mario from './portafolio/mario.vue'
import raul from './portafolio/raul.vue'
import rostros from './portafolio/rostros.vue'
import valentin from './portafolio/valentin.vue'
import schnauzer from './portafolio/schnauzer.vue'
import trifuerza from './portafolio/trifuerza.vue'
import tulipan from './portafolio/tulipan.vue'
import ricardo from './portafolio/ricardo.vue'

export default {
  components: {
    adn,
    edgar,
    erick,
    guns,
    dux,
    femsa,
    mario,
    raul,
    rostros,
    valentin,
    schnauzer,
    trifuerza,
    tulipan,
    ricardo
  }
}
</script>
